<template>
  <div class="lisence-bd tb" v-if="funcView.lockingMachineRecord_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <el-form-item v-if="funcView.lockingMachineRecord_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click.native="exportTable('deviceScrapExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.lockingMachineRecord_export }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('report_lockingMachineRecord.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!-- 产品型号 -->
        <el-form-item :label="$t('report_lockingMachineRecord.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 锁机时间 -->
        <el-form-item :label="$t('report_lockingMachineRecord.suo_ji_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"></custom-date-picker>
        </el-form-item>
        <!-- 旧机身号 -->
        <el-form-item :label="$t('report_lockingMachineRecord.ku_cun_fang')">
          <el-input v-model="formSearch.orgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 旧Modem SN -->
        <el-form-item :label="$t('report_lockingMachineRecord.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>

      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" >
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'lockingMachineRecord',
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'locking_machineRecord',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        orgName: '',
        afterServiceName: '',
        productCode: '',
        timer: '',
        lockStartTime: '',
        lockEndTime: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      link: null,
    };
  },
  mounted: function () {
    this.getTableColumn();

    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.lockStartTime = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : null;
      this.formSearch.lockEndTime = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : null;
      this.$getJSON(apis.LisencePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },

  },
};
</script>

<style lang="scss"></style>
